import ApplicationJSONAPISerializer from 'district-ui-client/serializers/application'

export default class SchoolClassSerializer extends ApplicationJSONAPISerializer {}
